import { ipoCenterPageLink } from '@/root/constants'

export interface LinkData {
  title: string
  link: string
  rel?: 'noreferrer'
  target?: '_top'
  type?: 'mail'
}

interface OneDataItem {
  heading: string
  listItems: Array<LinkData>
}

type Data = OneDataItem[]

export const mainNavData: Data = [
  {
    heading: 'PRODUCTS',
    listItems: [
      {
        title: 'Mutual Funds',
        link: '/mutual-funds',
      },
      {
        title: 'INDstocks',
        link: '/stocks',
      },
      {
        title: 'US Stocks',
        link: '/us-stocks',
      },
      {
        title: 'IPO',
        link: ipoCenterPageLink,
      },
      // {
      //   title: 'Bonds',
      //   link: '/bonds',
      // },
      {
        title: 'Fixed Deposit',
        link: '/fixed-deposit',
      },
      {
        title: 'Calculators',
        link: '/calculators',
      },
      {
        title: 'Credit Score',
        link: '/check-free-credit-score',
      },
    ],
  },
  {
    heading: 'INDMONEY',
    listItems: [
      {
        title: 'About Us',
        link: '/about',
      },
      {
        title: 'Blog',
        link: '/blog',
      },
      {
        title: 'Privacy Policy',
        link: '/privacy-policy',
      },
      {
        title: 'Terms & Conditions',
        link: '/terms-of-services',
      },
      {
        title: 'Legal & Regulatory',
        link: '/page/policy-center',
      },
      {
        title: 'Grievance Redressal Policy',
        link: '/grievance-redressal-policy',
      },
      {
        title: 'Sitemap',
        link: '/sitemap',
      },
    ],
  },
  {
    heading: 'QUICK LINKS',
    listItems: [
      {
        title: 'Customer Service',
        link: '/customer-service',
      },
      { title: 'Fraud Awareness', link: '/page/fraud-awareness' },
    ],
  },
]

export const goldRates = [
  {
    title: 'Gold Rate in India',
    link: '/gold-rates',
  },
  {
    title: 'Gold Rate in Delhi',
    link: '/gold-rates/delhi',
  },
  {
    title: 'Gold Rate in Mumbai',
    link: '/gold-rates/mumbai',
  },
  {
    title: 'Gold Rate in Bangalore',
    link: '/gold-rates/bangalore',
  },
  {
    title: 'Gold Rate in Chennai',
    link: '/gold-rates/chennai',
  },
  {
    title: 'Gold Rate in Kolkata',
    link: '/gold-rates/kolkata',
  },
  {
    title: 'Gold Rate in Hyderabad',
    link: '/gold-rates/hyderabad',
  },
  {
    title: 'Gold Rate in Pune',
    link: '/gold-rates/pune',
  },
  {
    title: 'Gold Rate in Vijayawada',
    link: '/gold-rates/vijayawada',
  },
]

export const popularIndex = [
  {
    title: 'All Indices',
    link: '/indices',
  },
  {
    title: 'Nifty 50',
    link: '/indices/nifty-50',
  },
  {
    title: 'Sensex',
    link: '/indices/sensex',
  },
  {
    title: 'Bank Nifty',
    link: '/indices/bank-nifty',
  },
  {
    title: 'BSE Small Cap',
    link: '/indices/bse-small-cap',
  },
  {
    title: 'Nifty Smallcap 250',
    link: '/indices/nifty-smallcap-250',
  },
  {
    title: 'Nifty Midcap 100',
    link: '/indices/nifty-midcap-100',
  },
  {
    title: 'Bankex',
    link: '/indices/bankex',
  },
  {
    title: 'Nifty Next 50',
    link: '/indices/nifty-next-50',
  },
  {
    title: 'Nifty IT',
    link: '/indices/nifty-it',
  },
  {
    title: 'Nifty Metal',
    link: '/indices/nifty-metal',
  },
  {
    title: 'Dow Jones Industrial Average',
    link: '/indices/global-indices/dow-jones-industrial-average',
  },
  {
    title: 'S&P 500',
    link: '/indices/global-indices/s-p-500',
  },
  {
    title: 'Nasdaq 100',
    link: '/indices/global-indices/nasdaq-100',
  },
  {
    title: 'Russell 2000 Index',
    link: '/indices/global-indices/russell-2000-index',
  },
]

export const market = [
  {
    title: 'Market Today',
    link: '/market',
  },
]

export const IndianMarketStocks = [
  {
    title: 'HDFC Share Price',
    link: '/stocks/hdfc-bank-ltd-share-price',
  },
  {
    title: 'SBI Share Price',
    link: '/stocks/state-bank-of-india-share-price',
  },
  {
    title: 'Paytm Share Price',
    link: '/stocks/one-97-communications-ltd-share-price',
  },
  {
    title: 'Eternal Share Price',
    link: '/stocks/eternal-ltd-share-price',
  },
  {
    title: 'Axis Bank Share Price',
    link: '/stocks/axis-bank-ltd-share-price',
  },
  {
    title: 'ICICI Bank Share Price',
    link: '/stocks/icici-bank-ltd-share-price',
  },
  {
    title: 'Bajaj Finance Share Price',
    link: '/stocks/bajaj-finance-ltd-share-price',
  },
  {
    title: 'Maruti Suzuki Share Price',
    link: '/stocks/maruti-suzuki-india-ltd-share-price',
  },
  {
    title: 'Bajaj Finserv Share Price',
    link: '/stocks/bajaj-finserv-ltd-share-price',
  },
  {
    title: 'Tata Motors Share Price',
    link: '/stocks/tata-motors-ltd-share-price',
  },
  {
    title: 'Kotak Mahindra Bank Share Price',
    link: '/stocks/kotak-mahindra-bank-ltd-share-price',
  },
  {
    title: 'TCS Share Price',
    link: '/stocks/tata-consultancy-services-ltd-share-price',
  },
  {
    title: 'IndusInd Bank Share Price',
    link: '/stocks/indusind-bank-ltd-share-price',
  },
  {
    title: 'Infosys Share Price',
    link: '/stocks/infosys-ltd-share-price',
  },
  {
    title: 'Wipro Share Price',
    link: '/stocks/wipro-ltd-share-price',
  },
  {
    title: 'Asian Paints Share Price',
    link: '/stocks/asian-paints-ltd-share-price',
  },
]

export const ipos = [
  {
    title: 'IPO Home Page',
    link: '/ipo',
  },
  // {
  //   title: 'Current IPO',
  //   link: '/ipo/current-ipo',
  // },
  // {
  //   title: 'Upcoming IPO',
  //   link: '/ipo/upcoming-ipo',
  // },
  // {
  //   title: 'Closed IPO',
  //   link: '/ipo/closed-ipo',
  // },
  {
    title: 'Recently Listed IPO',
    link: '/ipo/recently-listed-ipos',
  },
  {
    title: 'IPO Allotment Status',
    link: '/ipo/ipo-allotment-status',
  },
]

export const mutualFundsToInvest = [
  {
    title: 'Quant Small Cap Fund',
    link: '/mutual-funds/fund/quant-small-cap-fund-growth-option-direct-plan/611',
  },
  {
    title: 'ICICI Prudential Commodities Fund',
    link: '/mutual-funds/fund/icici-prudential-commodities-fund-direct-growth/1005178',
  },
  {
    title: 'Nippon India Small Cap Fund',
    link: '/mutual-funds/fund/nippon-india-small-cap-fund-direct-plan-growth-plan/3598',
  },
  {
    title: 'Parag Parikh Flexi Cap Fund',
    link: '/mutual-funds/fund/parag-parikh-flexi-cap-direct-growth/3229',
  },
  {
    title: 'Groww Nifty Total Market Index Fund',
    link: '/mutual-funds/fund/groww-nifty-total-market-index-fund-direct-growth/1044315',
  },
  {
    title: 'SBI Small Midcap Fund',
    link: '/mutual-funds/fund/sbi-small-cap-fund-direct-plan-growth/3603',
  },
  {
    title: 'Tata Digital India Fund',
    link: '/mutual-funds/fund/tata-digital-india-fund-direct-growth/3499',
  },
  {
    title: 'Axis Small Cap Fund',
    link: '/mutual-funds/fund/axis-small-cap-fund-direct-growth/5890',
  },
  {
    title: 'ICICI Prudential Technology Fund',
    link: '/mutual-funds/fund/icici-prudential-technology-fund-direct-plan-growth/3337',
  },
  {
    title: 'HDFC Index Fund Sensex Plan',
    link: '/mutual-funds/fund/hdfc-index-fund-sensex-plan-direct-plan/3897',
  },
  {
    title: 'HDFC Small Cap Fund',
    link: '/mutual-funds/fund/hdfc-small-cap-fund-direct-growth-option/3580',
  },
  {
    title: 'Canara Robeco Small Cap Fund',
    link: '/mutual-funds/fund/canara-robeco-small-cap-fund-direct-growth/1003191',
  },
  {
    title: 'Tata Small Cap Fund',
    link: '/mutual-funds/fund/tata-small-cap-fund-direct-growth/1002043',
  },
  {
    title: 'UTI Nifty Fund',
    link: '/mutual-funds/fund/uti-nifty-50-index-fund-growth-option-direct/5603',
  },
]

export const popularMutualFundsAMC = [
  {
    title: 'SBI Mutual Fund',
    link: '/mutual-funds/amc/sbi-mutual-fund',
  },
  {
    title: 'Nippon India Mutual Fund',
    link: '/mutual-funds/amc/nippon-india-mutual-fund',
  },
  {
    title: 'HDFC Mutual Fund',
    link: '/mutual-funds/amc/hdfc-mutual-fund',
  },
  {
    title: 'Quant Mutual Fund',
    link: '/mutual-funds/amc/quant-mutual-fund',
  },
  {
    title: 'Axis Mutual Fund',
    link: '/mutual-funds/amc/axis-mutual-fund',
  },
  {
    title: 'Tata Mutual Fund',
    link: '/mutual-funds/amc/tata-mutual-fund',
  },
  {
    title: 'ICICI Prudential Mutual Fund',
    link: '/mutual-funds/amc/icici-prudential-mutual-fund',
  },
  {
    title: 'UTI Mutual Fund',
    link: '/mutual-funds/amc/uti-mutual-fund',
  },
  {
    title: 'Aditya Birla Mutual Fund',
    link: '/mutual-funds/amc/aditya-birla-mutual-fund',
  },
  {
    title: 'Kotak Mutual Fund',
    link: '/mutual-funds/amc/kotak-mutual-fund',
  },
]

export const popularFundsbyCategory = [
  {
    title: 'Index Fund',
    link: '/mutual-funds/equity/index-funds',
  },
  {
    title: 'Nifty 50 Index Fund',
    link: '/mutual-funds/equity/nifty-50-index-funds',
  },
  {
    title: 'Small Cap Fund',
    link: '/mutual-funds/equity/small-cap-funds',
  },
  {
    title: 'SIP Mutual Fund',
    link: '/mutual-funds/mutual-fund-sip-investment',
  },
  {
    title: 'Flexi Cap Fund',
    link: '/mutual-funds/equity/flexi-cap',
  },
  {
    title: 'Multi Asset Fund',
    link: '/mutual-funds/hybrid/multi-asset-funds',
  },
  {
    title: 'Arbitrage Fund',
    link: '/mutual-funds/hybrid/arbitrage-funds',
  },
  {
    title: 'Mid Cap Fund',
    link: '/mutual-funds/equity/mid-cap-funds',
  },
  {
    title: 'Nifty Next 50 Index Fund',
    link: '/mutual-funds/equity/nifty-next-50-index-funds',
  },
  {
    title: 'Money Market Fund',
    link: '/mutual-funds/debt/money-market-funds',
  },
  {
    title: 'Multi Cap Fund',
    link: '/mutual-funds/equity/multi-cap-funds',
  },
  {
    title: 'Liquid Fund',
    link: '/mutual-funds/debt/liquid-funds',
  },
  {
    title: 'Large Cap Fund',
    link: '/mutual-funds/equity/large-cap-funds',
  },
  {
    title: 'Equity Savings Fund',
    link: '/mutual-funds/hybrid/equity-savings',
  },
]

export const USStocks = [
  {
    title: 'Tesla',
    link: '/us-stocks/tesla-inc-share-price-tsla',
  },
  {
    title: 'Amazon',
    link: '/us-stocks/amazon-com-inc-share-price-amzn',
  },
  {
    title: 'NVIDIA',
    link: '/us-stocks/nvidia-corporation-share-price-nvda',
  },
  {
    title: 'Apple',
    link: '/us-stocks/apple-inc-share-price-aapl',
  },
  {
    title: 'Microsoft',
    link: '/us-stocks/microsoft-corporation-share-price-msft',
  },
  {
    title: 'Adobe',
    link: '/us-stocks/adobe-systems-inc-share-price-adbe',
  },
  {
    title: 'AMD',
    link: '/us-stocks/advanced-micro-devices-inc-share-price-amd',
  },
  {
    title: 'Intel',
    link: '/us-stocks/intel-corporation-share-price-intc',
  },
  {
    title: 'Salesforce',
    link: '/us-stocks/salesforce-inc-share-price-crm',
  },
  {
    title: 'PayPal',
    link: '/us-stocks/paypal-holdings-inc-share-price-pypl',
  },
  {
    title: 'Netflix',
    link: '/us-stocks/netflix-inc-share-price-nflx',
  },
  {
    title: 'Uber',
    link: '/us-stocks/uber-technologies-inc-share-price-uber',
  },
  {
    title: 'Starbucks',
    link: '/us-stocks/starbucks-corporation-share-price-sbux',
  },
  {
    title: 'Berkshire Hathaway',
    link: '/us-stocks/berkshire-hathaway-inc-class-a-share-price-brk.a',
  },
  {
    title: 'Alphabet',
    link: '/us-stocks/alphabet-inc-share-price-goog',
  },
  {
    title: 'Coca Cola',
    link: '/us-stocks/coca-cola-company-the-share-price-ko',
  },
]

export const InvestmentCalculators = [
  {
    title: 'SIP Calculator',
    link: '/calculators/sip-calculator',
  },
  {
    title: 'EMI Calculator',
    link: '/calculators/emi-calculator',
  },
  {
    title: 'Compound Interest Calculator',
    link: '/calculators/compound-interest-calculator',
  },
  {
    title: 'Income Tax Calculator',
    link: '/calculators/income-tax-calculator',
  },
  {
    title: 'Home Loan EMI Calculator',
    link: '/calculators/home-loan-emi-calculator',
  },
  {
    title: 'PPF Calculator',
    link: '/calculators/ppf-calculator',
  },
  {
    title: 'NPS Calculator',
    link: '/calculators/nps-calculator',
  },
  {
    title: 'GST Calculator',
    link: '/calculators/gst-calculator',
  },
  {
    title: 'Gratuity Calculator',
    link: '/calculators/gratuity-calculator',
  },
  {
    title: 'Personal Loan EMI Calculator',
    link: '/calculators/personal-loan-emi-calculator',
  },
  {
    title: 'Lumpsum Calculator',
    link: '/calculators/lumpsum-calculator',
  },
  {
    title: 'RD Calculator',
    link: '/calculators/rd-calculator',
  },
  {
    title: 'Car Loan EMI Calculator',
    link: '/calculators/car-loan-emi-calculator',
  },
  {
    title: 'SWP Calculator',
    link: '/calculators/swp-calculator',
  },
  {
    title: 'CAGR Calculator',
    link: '/calculators/cagr-calculator',
  },
  {
    title: 'Step Up SIP Calculator',
    link: '/calculators/step-up-sip-calculator',
  },
]

export const usStocksCategoriesLinks = [
  {
    title: 'US Exchange Traded Funds',
    link: '/us-stocks/top-etfs',
  },
  {
    title: 'US Tech Stocks|',
    link: '/us-stocks/top-tech-stocks',
  },
  {
    title: 'US Top Gainers|',
    link: '/us-stocks/top-gainers',
  },
  {
    title: 'US Top Losers',
    link: '/us-stocks/top-losers',
  },
  {
    title: 'Top Finance US stocks',
    link: '/us-stocks/fin-stocks',
  },
  {
    title: 'Top Energy US stocks',
    link: '/us-stocks/top-energy',
  },
  {
    title: 'Top Pharma US stocks',
    link: '/us-stocks/us-pharma-companies',
  },
  {
    title: 'FAANG',
    link: '/us-stocks/faang',
  },
]

export const socialIconList: Array<{
  title: string
  icon: string
  link: string
}> = [
  {
    title: 'INDmoney Facebook',
    icon: 'iaFacebook',
    link: 'https://www.facebook.com/indmoney',
  },
  {
    title: 'INDmoney LinkedIn',
    icon: 'iaLinkedin',
    link: 'https://in.linkedin.com/company/indmoney',
  },
  {
    title: 'INDmoney X',
    icon: 'iaTwitter',
    link: 'https://x.com/INDmoneyApp/',
  },
  {
    title: 'INDmoney YouTube',
    icon: 'iaYoutube',
    link: 'https://www.youtube.com/channel/UCm7xZ9sbqhuARuDDcckh8Jg',
  },
  {
    title: 'INDmoney Instagram',
    icon: 'iaInstagram',
    link: 'https://www.instagram.com/indmoneyapp/',
  },
  {
    title: 'INDmoney Telegram',
    icon: 'iatelegram',
    link: 'https://t.me/indmoneyofficial',
  },
]
